<template>
  <div class="daily dailybg">
    <!-- <div class="navbar">
       <navbar :titlename="titlename"></navbar>
    </div> -->

    <div class="backbtn">
      <backbtn></backbtn>
    </div>

    <div class="downpicbox" :style="{display:showdownpicbox}">
      <div id="vanshowp"></div>
    </div>
    <div class="downpicboxbg" v-if="showdownpic">
      <p class="closeicon" @click="closevanshow">
        <van-icon size="28px" name="cross" color="#fff" />
      </p>
      <p class="downtext">请长按图片选择保存图片到手机相册</p>
    </div>

    <div class="dailybody">
      <div class="bentibox">
        <div class="dailyall">
          <div class="dailybox">
            <div class="dailypic">
              <div class="timemain">
                <div class="timeday">{{timeday}}</div>
                <div class="xianxian"></div>
                <div class="timemonth">{{timemonth}}</div>
                <div class="timeyear">{{timeyear}}</div>
              </div>
              <img :src="imgarr[bigimgsize]" onclick="return false" />

            </div>
            <div class="dailybottom">
              <div class="dailyb-right">
                <dl class="dailyb-rightdl02">
                  <dd @click="changebigsize"><em><img src="../../assets/images/mine_icon_change.png" /></em><i>换一张</i></dd>
                  <dt><img :src="dailydata.applets_qrcode" /></dt>
                </dl>
              </div>
              <div class="dailyb-left">
                <dl>
                  <dt v-if="dailydata.avatar_url"><img :src="dailydata.avatar_url" /></dt>
                  <dt v-else><img :src="avatar_url" /></dt>
                  <dd v-if="dailydata.name">{{dailydata.name}}</dd>
                  <dd v-else>默认名称</dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="addImage" style=" position: absolute; top:0.81rem;left:50%; height:0; margin-left:-8.1rem; overflow:hidden;"></div>
      <div class="hello">
        <div ref="thehtml">
          <div class="dailyall">
            <div class="dailybox">
              <div class="dailypic">
                <div class="timemain">
                  <div class="timeday">{{timeday}}</div>
                  <div class="xianxian"></div>
                  <div class="timemonth">{{timemonth}}</div>
                  <div class="timeyear">{{timeyear}}</div>
                </div>
                <img :src="imgarr[bigimgsize]" />
              </div>
              <div class="dailybottom">
                <div class="dailyb-right">
                  <dl class="dailyb-rightdl01">
                    <dt><img :src="dailydata.applets_qrcode" crossOrigin="anonymous" /></dt>
                    <dd>扫一扫,识别二维码</dd>
                  </dl>
                </div>
                <div class="dailyb-left">
                  <dl>
                    <dt v-if="dailydata.avatar_url"><img :src="dailydata.avatar_url" /></dt>
                    <dt v-else><img :src="avatar_url" /></dt>
                    <dd v-if="dailydata.name">{{dailydata.name}}</dd>
                    <dd v-else>默认名称</dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <p class="bctext">保存到手机相册，然后发送给朋友吧</p>
      <div class="savebtnbox" v-if="generatorevent">
        <button @click="generatorImage" class="savetobtn">保存到手机</button>
      </div>
      <div class="savebtnbox" v-else>
        <button @click="saveImage" class="savetobtn">保存到手机</button>
      </div>
      <screen-capture ref="sc" :html="html"></screen-capture>
    </div>

  </div>
</template>

<script>
import ScreenCapture from "../public/ScreenCapture";
import navbar from "../public/navbar.vue";
import html2canvas from "html2canvas";
import backbtn from "../public/backbtn";
import { getdaily } from "../../api/api";
import { Toast } from "vant";

export default {
  name: "mycart",
  components: {
    ScreenCapture,
    navbar,
    backbtn
  },
  props: {
    msg: String
  },
  data () {
    return {
      titlename: "每日海报",
      html: null,
      imgarr: [
        require("../../assets/images/hb_1-min.png"),
        require("../../assets/images/hb_2-min.png"),
        require("../../assets/images/hb_3-min.png"),
        require("../../assets/images/hb_4-min.png"),
        require("../../assets/images/hb_5-min.png"),
        require("../../assets/images/hb_6-min.png"),
        require("../../assets/images/hb_7-min.png"),
        require("../../assets/images/hb_8-min.png"),
        require("../../assets/images/hb_9-min.png"),
        require("../../assets/images/hb_10-min.png"),
        require("../../assets/images/hb_11-min.png"),
        require("../../assets/images/hb_12-min.png"),
        require("../../assets/images/hb_13-min.png"),
        require("../../assets/images/hb_14-min.png"),
        require("../../assets/images/hb_15-min.png"),
        require("../../assets/images/hb_16-min.png"),
        require("../../assets/images/hb_17-min.png"),
        require("../../assets/images/hb_18-min.png"),
        require("../../assets/images/hb_19-min.png"),
        require("../../assets/images/hb_20-min.png"),
        require("../../assets/images/hb_21-min.png"),
        require("../../assets/images/hb_22-min.png"),
        require("../../assets/images/hb_23-min.png"),
        require("../../assets/images/hb_24-min.png"),
        require("../../assets/images/hb_25-min.png"),
        require("../../assets/images/hb_26-min.png"),
        require("../../assets/images/hb_27-min.png"),
        require("../../assets/images/hb_28-min.png"),
        require("../../assets/images/hb_29-min.png"),
        require("../../assets/images/hb_30-min.png"),
        require("../../assets/images/hb_41-min.png"),
        require("../../assets/images/hb_42-min.png"),
        require("../../assets/images/hb_43-min.png"),
        require("../../assets/images/hb_44-min.png"),
        require("../../assets/images/hb_45-min.png"),
        require("../../assets/images/hb_46-min.png"),
        require("../../assets/images/hb_47-min.png"),
        require("../../assets/images/hb_48-min.png"),
        require("../../assets/images/hb_49-min.png"),
        require("../../assets/images/hb_50-min.png"),
        require("../../assets/images/hb_51-min.png"),
        require("../../assets/images/hb_52-min.png"),
        require("../../assets/images/hb_53-min.png"),
        require("../../assets/images/hb_54-min.png"),
        require("../../assets/images/hb_55-min.png"),
        require("../../assets/images/hb_56-min.png"),
        require("../../assets/images/hb_57-min.png"),
        require("../../assets/images/hb_58-min.png"),
        require("../../assets/images/hb_59-min.png"),
        require("../../assets/images/hb_60-min.png")
      ],
      bigimgsize: "",
      timeday: "",
      timemonth: "",
      timeyear: "",
      dailydata: {},
      avatar_url: require("../../assets/images/moren.jpg"),
      avatar: require("../../assets/images/qrcode.jpg"),
      screenshotImage: "",
      showdownpic: false,
      showdownpicbox: 'block',
      generatorevent: true,
      imgsrc: ''
      //morentx:require('../../assets/images/moren.jpg')
    };
  },
  created () {
    document.title = this.titlename;
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth();
    var en_mon_arr = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Spt",
      "Oct",
      "Nov",
      "Dec"
    ];
    var themonth = en_mon_arr[month];
    const day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    this.timeday = day;
    this.timemonth = themonth;
    this.timeyear = year;

    Toast.loading({
      mask: true,
      message: "加载中..."
    });

    let that = this;
    getdaily()
      .then(res => {
        if (res.data.code == 200) {
          //that.imgarr=res.data.data.poster;

          that.dailydata = res.data.data;
          //that.avatar = res.data.data.applets_qrcode

          if (res.data.data.avatar_url) {
            that.avatar_url = res.data.data.avatar_url;
          }

          Toast.clear();
        } else {
          Toast.fail("加载失败！");
        }
      })
      .catch(err => {
      });
  },
  mounted () {
    this.html = this.$refs.thehtml;

    let bigimgsize = Math.floor(this.imgarr.length * Math.random());
    this.bigimgsize = bigimgsize;
  },
  methods: {
    closevanshow () {
      //let vanshowp = document.getElementById('vanshowp');
      this.showdownpicbox = 'none';
      this.showdownpic = false;
    },
    saveImage () {
      this.showdownpicbox = 'block';
      this.showdownpic = true;
    },
    generatorImage () {
      let that = this;
      const toast = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner",
        message: "海报下载中..."
      });

      let second = 3;
      const timer = setInterval(() => {
        second--;
        if (second) {
          toast.message = `海报下载中...`;
        } else {
          clearInterval(timer);
          Toast.clear();
        }
      }, 1000);

      this.$refs.sc.capture();
      let addImage = document.getElementById("addImage");

      setTimeout(download, 3000);

      function download () {
        let ocanvas = document.getElementsByTagName("canvas")[0];
        html2canvas(ocanvas, {
          useCORS: true
        }).then(canvas => {
          that.showdownpic = true;
          that.showdownpicbox = true;
          addImage.append(ocanvas);
          let link = document.createElement("img");
          link.src = canvas.toDataURL();
          link.style.display = "block";
          link.style.width = "100%";
          var vanshowp = document.getElementById("vanshowp");
          vanshowp.appendChild(link);
          that.generatorevent = false;
          setTimeout(downloadafter, 1500);
        });

      }


      function downloadafter () {
        //addImage.innerHTML=''
        Toast.success('请长按图片选择保存图片到相册');
      }
    },
    changebigsize () {
      let bigimgsize = Math.floor(this.imgarr.length * Math.random());
      this.bigimgsize = bigimgsize;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >
@import "../../assets/css/reset.css";
#app {
  background: #f8f8f8;
}

.closeicon {
  text-align: right;
  padding-right: 1rem;
  padding-top: 0.8rem;
}
.downpicbox {
  position: fixed;
  width: 80%;
  left: 10%;
  top: 3rem;
  z-index: 10;
}
.downpicbox #vanshowp img {
  width: 100%;
}
.downpicboxbg .downtext {
  color: #fff;
  text-align: center;
  font-size: 0.75rem;
  position: absolute;
  bottom: 1rem;
  width: 100%;
}
.downpicboxbg {
  position: fixed;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 9;
}

.backbtn {
  position: fixed;
  left: 1rem;
  top: 1rem;
  z-index: 6;
}

.dailybg {
  background: #f8f8f8;
  height: 100%;
  overflow: hidden;
}
.dailybody {
  padding-top: 0.5rem;
  position: relative;
}
.navbar {
  position: fixed;
  z-index: 10;
}
.bentibox {
  position: absolute;
  top: 0.5rem;
  z-index: 5;
  width: 16.2rem;
  width: 100%;
}
#addImage {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
}

.hello {
  width: 16.2rem;
  margin: 0 auto;
  border-radius: 10px;
  background: none;
}
.thehtml {
  width: 16.2rem;
  margin: 0 auto;
  box-shadow: 0 0 10px #eee;
  border-radius: 10px;
  background: none;
}
.dailybox {
  width: 16.2rem;
  margin: 0 auto;
  box-shadow: 0 0 10px #eee;
  border-radius: 10px;
  background: none;
}
.dailybox .dailypic {
  border-radius: 10px;
  background: none;
  height: 19rem;
  overflow: hidden;
  position: relative;
}
.dailybox .dailypic .timemain {
  width: 2.5135135135135136rem;
  top: 1.43rem;
  right: 1.19rem;
  height: 3.27rem;
  border: 2px solid #fff;
  color: #fff;
  line-height: 0.81rem;
  position: absolute;
}
.dailybox .dailypic .timemain .timeday {
  width: 1.6216216216216217rem;
  font-size: 0.64rem;
  margin: 0 auto;
  padding-bottom: 0.16rem;
  padding-top: 0.16rem;
}
.dailybox .dailypic .timemain .xianxian {
  height: 2px;
  background: #fff;
  margin-left: 0.378rem;
  margin-right: 0.4rem;
}
.dailybox .dailypic .timemain .timemonth {
  margin-left: 0.378rem;
  font-size: 0.64rem;
  padding-top: 0.135rem;
}
.dailybox .dailypic .timemain .timeyear {
  margin-left: 0.378rem;
  font-size: 0.64rem;
}

.dailybox .dailypic img {
  width: 100%;
}
.dailybox .dailybottom {
  height: 5rem;
  background: #fff;
  border-radius: 10px;
}

.canvasdown {
  position: absolute;
  width: 100%;
  top: 0;
}

.dailybox .dailybottom .dailyb-left {
  width: 8rem;
}
.dailybox .dailybottom .dailyb-left dl {
  position: relative;
}
.dailybox .dailybottom .dailyb-left dl dt {
  padding-left: 1.1891891891891893rem;
  position: absolute;
  top: -1.6rem;
}
.dailybox .dailybottom .dailyb-left dl dt img {
  width: 3.2432432432432434rem;
  border-radius: 50%;
}
.dailybox .dailybottom .dailyb-left dl dd {
  padding-top: 2.1rem;
  color: #333;
  font-size: 0.81rem;
  text-align: center;
  width: 5rem;
  margin-left: 0.2rem;
}

.dailybox .dailybottom .dailyb-right {
  float: right;
  padding-right: 1rem;
  padding-top: 0.5rem;
}
.dailybox .dailybottom .dailyb-right dl.dailyb-rightdl01 dt {
  text-align: right;
  padding-right: 0.3rem;
  padding-top: 0.15rem;
}
.dailybox .dailybottom .dailyb-right dl.dailyb-rightdl01 dt img {
  width: 2.9rem;
}
.dailybox .dailybottom .dailyb-right dl.dailyb-rightdl01 dd {
  font-size: 0.54rem;
  color: #999999;
}

.dailybox .dailybottom .dailyb-right {
  float: right;
  padding-right: 1rem;
  padding-top: 0.5rem;
}
.dailybox .dailybottom .dailyb-right dl.dailyb-rightdl02 {
}
.dailybox .dailybottom .dailyb-right dl.dailyb-rightdl02 dt {
  padding-top: 0.15rem;
}
.dailybox .dailybottom .dailyb-right dl.dailyb-rightdl02 dt {
  text-align: right;
  padding-right: 0.3rem;
}
.dailybox .dailybottom .dailyb-right dl.dailyb-rightdl02 dt img {
  width: 2.9rem;
}
.dailybox .dailybottom .dailyb-right dl.dailyb-rightdl02 dd {
  font-size: 0.54rem;
  color: #999999;
  overflow: hidden;
}
.dailybox .dailybottom .dailyb-right dl.dailyb-rightdl02 dd img {
  width: 0.76rem;
}
.dailybox .dailybottom .dailyb-right dl.dailyb-rightdl02 dd em {
  float: left;
  padding-top: 0.1rem;
  padding-right: 0.1rem;
}
.dailybox .dailybottom .dailyb-right dl.dailyb-rightdl02 dd i {
  font-style: normal;
  padding-left: 0.2rem;
  font-size: 0.73rem;
  color: #febf12;
}

.bctext {
  text-align: center;
  font-size: 0.6486486486486487rem;
  color: #999999;
  padding-top: 0.6486486486486487rem;
}
.savebtnbox {
  padding-top: 0.3rem;
  width: 80%;
  margin: 0 auto;
  margin-bottom: 15rem;
}
.savebtnbox .savetobtn {
  height: 2.4324324324324325rem;
  font-size: 0.7567567567567568rem;
  color: #fff;
  line-height: 2.4324324324324325rem;
  border-radius: 1.3513513513513513rem;
  background: linear-gradient(to right, rgb(255, 189, 10), rgb(248, 218, 91));
  width: 100%;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/daily.vue